﻿import { FC } from 'react';
import { siteConfig } from '../../config/site';

export interface StructuredDataProps {
  type: 'organization' | 'product' | 'website';
  data?: Record<string, unknown>;
}

export const StructuredData: FC<StructuredDataProps> = ({ type, data = {} }) => {
  let schema: Record<string, unknown> = {};

  if (type === 'organization') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteConfig.siteName,
      url: siteConfig.baseUrl,
      logo: `${siteConfig.baseUrl}/connect-source-logo-header.png`,
      contactPoint: {
        '@type': 'ContactPoint',
        email: siteConfig.contactEmail,
        contactType: 'customer support'
      },
      ...data
    };
  } else if (type === 'website') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: siteConfig.siteName,
      url: siteConfig.baseUrl,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteConfig.baseUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string'
      },
      ...data
    };
  } else if (type === 'product') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      ...data
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

